import { BASE_URL } from 'constants/api';
import { stringify } from 'query-string';

import actions from './index';

export const ACTIONS = {
  GET: 'ONLINE_PLAN_COURSE_GET',
  GET_SUCCESS: 'ONLINE_PLAN_COURSE_GET_SUCCESS',
  GET_FAILURE: 'ONLINE_PLAN_COURSE_GET_FAILURE',

  INVALIDATE_LIST: 'ONLINE_PLAN_COURSE_INVALIDATE_ALL',
  INVALIDATE_ITEM: 'ONLINE_PLAN_COURSE_INVALIDATE_ITEM',
};

export const get = actions.get(
  planId => `${BASE_URL}/pricing/online-plan-courses/?plan_ids=${planId}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);
